import React from 'react';
import QrMatch from 'main/page/match/QrMatch';
import QrPrint from 'main/page/print/QrPrint';
import QrManage from "main/page/manage/QrManage";
import QrUnlock from "main/page/unlock/QrUnlock";
import QrUnclear from "main/page/unclear/QrUnclear";
import QrClear from "main/page/clear/QrClear";
import {
  Route,
  Switch
} from "react-router-dom";
import PropTypes from 'prop-types';

const Body = (props) => {
  const role = props.role;
	return(
		<Switch>
      {role === 'elocker_admin' &&
        <>
        <div className="boardbody">
          <Route path="/match">
              <QrMatch/>
          </Route>
          <Route path="/manage">
              <QrManage/>
          </Route>
          <Route path="/unlock">
              <QrUnlock/>
          </Route>
          <Route path="/print">
              <QrPrint/>
          </Route>
          <Route path="/unclear">
              <QrUnclear/>
          </Route>
          <Route path="/clear">
              <QrClear/>
          </Route>
          <Route path="/404">
              <h3 className="fade-in" style={{textAlign: 'center'}}>404 not found<br/><br/>
              <small>If needed, Please contact John Li via cshingli@polyu.edu.hk</small></h3>
          </Route>
        </div>
        </>
      }
      {role === 'user' &&
        <>
        <Route>
          <div className="boardbody">
              <h3 className="fade-in" style={{textAlign: 'center'}}>Access denied<br/><br/>
              <small>If needed, Please contact John Li via cshingli@polyu.edu.hk</small></h3>
          </div>
        </Route>
        </>
      }
      {role === 'guest' &&
        <Route>
          <div className="boardbody">
              <h3 className="fade-in" style={{textAlign: 'center'}}>404 not found<br/><br/>
              <small>If needed, Please contact John Li via cshingli@polyu.edu.hk</small></h3>
          </div>
        </Route>
      }
		</Switch>
	)
}
Body.propTypes = {
  role: PropTypes.string,
};
export default Body;
